import { createWidgetWithErrorBoundary } from '@alfa-bank/site-util-create-widget/create-widget-with-error-boundary';

import { InvestMediaportalHeadlinesNewsBlockDesktop as View } from '../../components/news-block/desktop/component';
import type { IDepsDesktop, TInvestMediaportalHeadlinesDesktop } from '../../models';

import { InvestMediaportalHeadlines as Component } from './component';

export const InvestMediaportalHeadlinesDesktop = createWidgetWithErrorBoundary<
    IDepsDesktop,
    TInvestMediaportalHeadlinesDesktop
>({ View })(Component);
